<template>
    <div class="max-w-3xl mx-auto bg-white border border-gray-300 rounded-lg shadow-lg px-6 py-4 mt-5">

        <div class="py-4">
            <div class="text-gray-700 text-2xl font-bold text-left">Add New Beneficiary</div>
            <p class="text-gray-700 text-left">Please fill the following details to add a New Beneficiary</p>

            <div class="mt-4 text-lg">
                <label class="mr-4">
                    <input type="radio" value="DMC" v-model="selectedBank" />
                    DMC Bank
                </label>
                <label class="ml-20">
                    <input type="radio" value="Other" v-model="selectedBank" />
                    Other Bank
                </label>
            </div>


            <div class="mt-4">
                <div class="mt-6" v-if="selectedBank === 'DMC'">
                    <div class="flex items-center mb-4">
                        <label class="w-1/3 text-gray-700 font-bold text-right pr-4">
                            Account Number:
                        </label>
                        <input type="text" v-model="dmcAccountNumber" placeholder="Enter Account Number"
                            class="w-2/3 px-3 py-2 border rounded" />
                    </div>
                    <p class="text-sm text-gray-500 pl-1">Sample account number: 1234567890</p>
                </div>

                <!-- Other Bank Fields -->
                <div v-else-if="selectedBank === 'Other'">
                    <div class="flex items-center mb-4">
                        <label class="w-1/3 text-gray-700 font-bold text-right pr-4">
                            Full Name:
                        </label>
                        <input type="text" v-model="otherFullName" placeholder="Enter Full Name"
                            class="w-2/3 px-3 py-2 border rounded" />
                    </div>
                    <div class="flex items-center mb-4">
                        <label class="w-1/3 text-gray-700 font-bold text-right pr-4">
                            Account Number:
                        </label>
                        <input type="text" v-model="otherAccountNumber" placeholder="Enter Account Number"
                            class="w-2/3 px-3 py-2 border rounded" />
                    </div>
                    <p class="text-sm text-gray-500 mb-5">Sample account number: 1234567890</p>
                    <div class="flex items-center mb-4">
                        <label class="w-1/3 text-gray-700 font-bold text-right pr-4">
                            IFSC Code:
                        </label>
                        <input type="text" v-model="ifscCode" placeholder="Enter IFSC Code"
                            class="w-2/3 px-3 py-2 border rounded" />
                    </div>
                    <div class="flex items-center mb-4">
                        <label class="w-1/3 text-gray-700 font-bold text-right pr-4">
                            Account Type:
                        </label>
                        <select v-model="accountType" class="w-2/3 px-3 py-2 border rounded">
                            <option value="" disabled>Select Account Type</option>
                            <option value="Savings">Savings</option>
                            <option value="Current">Current</option>
                        </select>
                    </div>
                    
                </div>
            </div>
            <div class="mt-6" v-if="selectedBank">
                <button class="bg-primary text-white px-4 py-2 rounded hover:bg-blue-600">
                    Add Beneficiary
                </button>
            </div>

        </div>
    </div>
</template>

<script>



export default {
    name: "AddBeneficiary",
    data() {
        return {
            selectedBank: "",
            dmcAccountNumber: "",
            otherFullName: "",
            otherAccountNumber: "",
            ifscCode: "",
            accountType: "",
        };
    },
    props: {
        user: Object
    },
    computed: {
    },
    created() {

    },
    methods: {

    }
};
</script>
